module.exports = __webpack_public_path__ + "static/media/MutedMouse.4cacfb88.png";